import { useQuery } from "@tanstack/react-query";
import { fetchMulheresKpis } from "../services/mulheres.service";
export function useMulheresKpis(activeSubTab, filters, dynamicSubtab) {
    var endpoint = dynamicSubtab === null || dynamicSubtab === void 0 ? void 0 : dynamicSubtab.kpisEndpoint;
    return useQuery({
        queryKey: ["mulheres", "kpis", activeSubTab, filters],
        enabled: Boolean(endpoint),
        queryFn: function () { return fetchMulheresKpis(endpoint, filters); },
    });
}
